import { createContext, useContext, useState, useEffect } from "react";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [activeRequests, setActiveRequests] = useState(0);
    const [timer, setTimer] = useState(null);

    useEffect(() => {
        if (activeRequests > 0) {
            setLoading(true);

            if (timer) clearTimeout(timer); // Hapus timer jika ada request API
        } else if (activeRequests === 0) {
            setTimer(
                setTimeout(() => {
                    setLoading(false);
                }, 2000) // Default loading 3 detik
            );
        }
    }, [activeRequests]); // Tambahkan `timer`
    
    const startLoading = () => setActiveRequests((prev) => prev + 1);
    const stopLoading = () => setActiveRequests((prev) => Math.max(0, prev - 1));

    return (
        <LoadingContext.Provider value={{ loading, startLoading, stopLoading }}>
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => useContext(LoadingContext);